import React, { Component } from "react";
import QrReader from "react-qr-reader";
import _ from "lodash";
import qrcodeIcon from "../assets/img/qrcodeIcon.svg";
import { Button, Modal } from "react-bootstrap";

/* ---------- HELPERS (FROM NEW CODE) ---------- */

const findHashInText = (text) => {
  if (!text || typeof text !== "string") return null;
  const match = text.match(/(0x[a-fA-F0-9]{64,})/i);
  return match ? match[1] : null;
};

const resolveTxHash = async (inputUrl) => {
  const directHash = findHashInText(inputUrl);

  if (
    directHash &&
    directHash.length >= 66 &&
    inputUrl.trim().length === directHash.length
  ) {
    return directHash;
  }

  const strategies = [
    async () => {
      const res = await fetch(
        `https://api.allorigins.win/get?url=${encodeURIComponent(inputUrl)}`,
      );
      const data = await res.json();
      return findHashInText(data.contents);
    },

    async () => {
      const res = await fetch(
        `https://corsproxy.io/?url=${encodeURIComponent(inputUrl)}`,
      );
      const text = await res.text();
      return findHashInText(res.url) || findHashInText(text);
    },

    async () => {
      const res = await fetch(
        `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(inputUrl)}`,
      );
      const text = await res.text();
      return findHashInText(text);
    },
  ];

  for (const strategy of strategies) {
    try {
      const result = await strategy();
      if (result) return result;
    } catch (e) {
      console.warn("Proxy failed, switching…", e);
    }
  }

  return directHash || inputUrl;
};

/* ---------- CLASS COMPONENT ---------- */

class QRReader extends Component {
  state = {
    result: "",
    showModal: false,
    error: null,
    loading: false,
  };

  handleScan = async (data) => {
    if (!data || this.state.loading) return;

    try {
      this.setState({ loading: true, error: null });

      const finalResult = await resolveTxHash(data);
      const isHash = /^0x[a-fA-F0-9]{64,}$/i.test(finalResult);

      if (!isHash) {
        this.setState({
          error: "Scanned code does not contain a valid transaction hash.",
          result: finalResult,
        });
      } else {
        this.setState({ result: finalResult });
      }
    } catch (e) {
      this.setState({
        error: "Failed to process QR code: " + e.message,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleError = (err) => {
    console.error("Scanner Error:", err);
    if (err?.message) {
      this.setState({ error: err.message, loading: false });
    }
  };

  renderCamAction = () => {
    const { result, error, loading } = this.state;

    if ((_.isEmpty(result) && !error) || loading) return null;

    return (
      <>
        <Button
          variant="secondary"
          onClick={() =>
            this.setState({ result: "", error: null, loading: false })
          }
        >
          Retake
        </Button>

        {result && !error && (
          <Button
            variant="primary"
            onClick={() => {
              this.setState({ showModal: false, result: "", error: null });
              this.props.onSubmit(result);
            }}
          >
            Confirm Hash
          </Button>
        )}
      </>
    );
  };

  render() {
    const { showModal, result, error, loading } = this.state;

    return (
      <div>
        {/* 🔒 OLD DESIGN PRESERVED */}
        <Button
          variant=""
          className="btn-outline-dark px-3"
          onClick={() =>
            this.setState({ showModal: true, result: "", error: null })
          }
        >
          <img
            src={qrcodeIcon}
            className="mx-2"
            style={{ width: "10px" }}
            alt="QR"
          />
          Scan QR
        </Button>

        <Modal
          show={showModal}
          onHide={() =>
            this.setState({ showModal: false, result: "", error: null })
          }
        >
          <Modal.Header closeButton>TX Hash Scanner</Modal.Header>

          <Modal.Body className="qr-code-modal">
            {error && (
              <div className="alert alert-danger">
                {error}
                {result && !loading && (
                  <div className="mt-2 small text-muted">
                    Raw content: {result}
                  </div>
                )}
              </div>
            )}

            {loading && (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status" />
                <p className="mt-2 font-weight-bold">
                  Obtaining raw Tx hash...
                </p>
              </div>
            )}

            {!loading && _.isEmpty(result) && !error && (
              <QrReader
                className="qr-code-section"
                delay={300}
                onError={this.handleError}
                onScan={this.handleScan}
                style={{ width: "100%" }}
              />
            )}

            {!loading && result && !error && (
              <div className="alert alert-success">
                <strong>Hash Found:</strong>
                <p
                  className="mb-0 mt-1"
                  style={{
                    wordBreak: "break-all",
                    fontFamily: "monospace",
                  }}
                >
                  {result}
                </p>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>{this.renderCamAction()}</Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default QRReader;
